import { Box, Stack } from '@mui/material';

import { ProgressBar } from '@/components';
import { lumiqColorIcon } from '@/images';

import { useOnboardingSteps } from '../useOnboardingSteps';

interface HeaderProps {
  Title: string | React.ReactNode;
  Subtitle?: string | React.ReactNode;
}

export const Header = ({ Title, Subtitle }: HeaderProps) => {
  const { steps, activeStepIndex } = useOnboardingSteps();

  return (
    <Box
      sx={{
        pb: 1,
        zIndex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Box
          component="img"
          src={lumiqColorIcon}
          alt="lumiq logo"
          sx={{ width: 56, height: 56 }}
        />
        <Box sx={{ width: 160 }}>
          <ProgressBar progressFraction={activeStepIndex / steps.length} />
        </Box>
      </Box>

      <Stack direction="column" gap={1.5}>
        {Title}
        {Subtitle && Subtitle}
      </Stack>
    </Box>
  );
};
